module.exports = __webpack_public_path__ + "static/media/Vaishnavi_Lokhande_FinalSOP.f901cb24.pdf";